import { AxiosResponse } from 'axios';

import { api } from 'tools/api-service';

import { PutPreferencesRequest } from './types/put-preferences.type';

export const putPreferences = async (
    payload: PutPreferencesRequest
): Promise<AxiosResponse<void>> => {
    const preferencesIds = payload.preferences
        .filter((preference) => preference.isSelected)
        .map((preference) => preference.id);

    const response = await api.put('/account/subscriptions', {
        selectedSubscriptions: preferencesIds,
    });

    return response;
};
